export const SIGN_UP_FAILED_REQUEST = "SIGN_UP_FAILED_REQUEST";
export const SIGN_UP_LOADING_REQUEST = "SIGN_UP_LOADING_REQUEST";
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const G2_CUSTOMER_SIGNUP_REQUEST = "G2_CUSTOMER_SIGNUP_REQUEST";

export const UPDATE_SIGN_UP_FORM = "UPDATE_SIGN_UP_FORM";
export const COMPANY_DETAILS_FORM = "COMPANY_DETAILS_FORM";
export const GET_ALL_STATE_LIST = "GET_ALL_STATE_LIST";

export const AUTH_TOKEN_REQUEST = "AUTH_TOKEN_REQUEST";
export const AUTH_TOKEN_FAILED = "AUTH_TOKEN_FAILED";
export const AUTH_TOKEN_SUCCESS = "AUTH_TOKEN_SUCCESS";

export const RESEND_EMAIL_REQUEST = "RESEND_EMAIL_REQUEST";
export const RESEND_EMAIL_FAILED = "RESEND_EMAIL_FAILED";
export const RESEND_EMAIL_SUCCESS = "RESEND_EMAIL_SUCCESS";

export const updateSignUpFrom = (formData) => ({
  type: UPDATE_SIGN_UP_FORM,
  payload: formData,
});

export const updateCompanyDetailsFrom = (formData) => ({
  type: COMPANY_DETAILS_FORM,
  payload: formData,
});
